import { ComponentChildren } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import { PortalsContainerElement, PortalsManagerContext } from './utilities';

interface PortalsManagerProps {
  children: ComponentChildren;
}

const ATTRIBUTES = {
  id: 'wbtxReviewsPortalsContainer',
  className: 'wbtx-reviews',
};

export function PortalsManager({ children }: PortalsManagerProps) {
  const [portalContainerElement, setPortalContainerElement] =
    useState<PortalsContainerElement>(null);

  useEffect(() => {
    let container = document.getElementById(
      ATTRIBUTES.id,
    ) as HTMLDivElement | null;

    if (container === null) {
      const element = document.createElement('div');

      element.id = ATTRIBUTES.id;
      element.className = ATTRIBUTES.className;

      document.body.appendChild(element);
      container = element;
    }

    setPortalContainerElement(container);
  }, []);

  return (
    <PortalsManagerContext.Provider
      value={{ container: portalContainerElement }}
    >
      {children}
    </PortalsManagerContext.Provider>
  );
}
